import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentV2Service, UtilService } from '../../shared/services';

@Component({
  selector: 'app-payment-sip-button',
  templateUrl: './payment-sip-button.component.html',
  styleUrls: ['./payment-sip-button.component.scss']
})
export class PaymentSipButtonComponent implements OnInit {

  @Input() config;
  @Output() btnClick = new EventEmitter();

  showDockBtn = false;

  constructor(
    public util: UtilService,
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit() {
  }

}
